import { useMutation, useQueryClient } from '@tanstack/react-query';
import { set } from 'idb-keyval';

import {
  getIDBKey,
  getKey as getLocalAssessmentKey,
} from '../queries/useLocalAssessment';
import usePhotoSession from '../queries/usePhotoSession';

const useSaveLocalAssessment = (photoSessionId, options) => {
  const queryClient = useQueryClient();

  const { data: photoSession } = usePhotoSession(photoSessionId);

  return useMutation({
    ...options,
    mutationFn: async ({ assessment }) => {
      try {
        const result = await set(getIDBKey(photoSessionId), {
          assessment,
          id: photoSessionId,
          houseId: photoSession?.house?.id,
        });

        await queryClient.invalidateQueries(
          getLocalAssessmentKey(photoSessionId),
        );

        return result;
      } catch (e) {
        return Promise.reject(e);
      }
    },
  });
};

export default useSaveLocalAssessment;
